import { render, staticRenderFns } from "./UserCardLandingPage.vue?vue&type=template&id=3725a906&scoped=true&"
import script from "./UserCardLandingPage.vue?vue&type=script&lang=js&"
export * from "./UserCardLandingPage.vue?vue&type=script&lang=js&"
import style0 from "./UserCardLandingPage.vue?vue&type=style&index=0&id=3725a906&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3725a906",
  null
  
)

export default component.exports